import { z } from 'zod'

export const cpeOrderItemSchema = z.object({
  id: z.string().uuid(),
  ecommerceItemId: z.string().uuid().optional(),
  sku: z.string(),
  description: z.string(),
  quantity: z.number().int().positive(),
})

export const cpeOrderSchema = z.object({
  id: z.string().uuid(),
  ecommerceOrderId: z.string().optional(),
  broadbandOrderId: z.string().uuid(),
  memberId: z.string(),
  mcfRequestId: z.string().uuid(),
  status: z.string(),
  deliveryStatus: z.string().optional(),
  stateDescription: z.string(),
  trackingNumber: z.string().optional(),
  packageNumber: z.number().optional(),
  trackingLink: z.string().optional(),
  items: z.array(cpeOrderItemSchema),
  estimatedArrivalDateTime: z.string().datetime().optional(),
  lastUpdateDateTime: z.string().datetime().optional(),
  shippable: z.boolean(),
  cancellable: z.boolean(),
  displayableOrderId: z.string().optional(),
  expectedCompletionDate: z.string().optional(),
  address: z
    .object({
      name: z.string().optional(),
      addressLine1: z.string().optional(),
      addressLine2: z.string().optional(),
      city: z.string().optional(),
      postalCode: z.string().optional(),
      countryCode: z.string().optional(),
      phone: z.string().optional(),
    })
    .optional(),
})

export type CpeOrder = z.infer<typeof cpeOrderSchema>

export const cpeOrderRequestSchema = z.object({
  broadbandOrderId: z.string(),
})

export const cpeOrderResponseSchema = z.array(cpeOrderSchema)
